module.exports = __webpack_public_path__ + "img/Transverse Cracking_moderate to high severity.78b5b2ef.jpg";